import React, { useMemo } from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Head from './Head';
import Body from './Body';

import useShiftSelected from '../../../../utils/hooks/useShiftSelected';

const DripFeedTable = ({
  isLoading,
  items,
  config,
  sort,
  filters,
  values,
  setValues,
  setOpenModal,
  setModalData,
  onSortTable,
  onChangeSelectService,
  fetchServices,
}) => {
  const itemsIds = useMemo(() => items?.filter((item) => item?.status === 1)?.map((i) => i.id), [items]);

  const onChange = useShiftSelected(itemsIds, values);

  const onChangeCheck = (event, item) => {
    const nextValue = onChange(event, item?.id);
    setValues(nextValue);
  };

  const onChangeCheckAll = (e) => {
    if (e.target.value === 'checkAll' && e.target.checked) {
      return setValues([...items.filter((item) => item?.status === 1).map((item) => item.id)]);
    }
    if (e.target.value === 'checkAll' && !e.target.checked) {
      return setValues([]);
    }
  };

  const handleSelect = (args, actionType) => {
    const { key } = args;
    setModalData({
      actionKey: key,
      actionType,
      ...args,
    });

    switch (actionType) {
    case 'single':
    case 'mass':
      setOpenModal('confirm');
      break;

    default:
      break;
    }
  };

  return (
    <Table className="table__dripfeed">
      <Head
        config={config}
        sort={sort}
        filters={filters}
        values={values}
        handleSelectMass={handleSelect}
        onSortTable={onSortTable}
        onChangeCheck={onChangeCheckAll}
        onChangeSelectService={onChangeSelectService}
        fetchServices={fetchServices}
      />
      <Body isLoading={isLoading} items={items} values={values} config={config} handleSelect={handleSelect} onChangeCheck={onChangeCheck} />
    </Table>
  );
};

DripFeedTable.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  sort: PropTypes.object,
  filters: PropTypes.object,
  values: PropTypes.array,
  setValues: PropTypes.func,
  setOpenModal: PropTypes.func,
  setModalData: PropTypes.func,
  onSortTable: PropTypes.func,
  onChangeSelectService: PropTypes.func,
  fetchServices: PropTypes.func,
};

export default DripFeedTable;
